import { Component, OnInit, Inject } from '@angular/core';
import { ClientNotificationService } from '../../data/client-nfs.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClientNotification } from '../../data/client-nfs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { trackEntityById } from 'projects/core/src/public-api';

@Component({
    selector: 'app-nfs-emails-dialog',
    templateUrl: './nfs-emails-dialog.component.html',
    styleUrls: ['./nfs-emails-dialog.component.scss']
})
export class NfsEmailsDialogComponent implements OnInit {

    clientNf: ClientNotification;
    emails = [];

    submitLoading: boolean;

    textAreaMessage: string;

    trackEntityById = trackEntityById;
    constructor(
        private snackBar: MatSnackBar,
        private clientNotificationService: ClientNotificationService,
        protected dialog: MatDialog,
        protected dialogRef: MatDialogRef<NfsEmailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: {
            clientNf: ClientNotification,
            textAreaMessage: string
        }) {
        this.clientNf = data.clientNf;
        this.textAreaMessage = data.textAreaMessage;

        if (this.clientNf.sentTo) {
            this.emails = [this.clientNf.sentTo]
        }
        else {
            this.emails = this.clientNf.project.customer.billingInfoContact.email.split(', ');
        }
    }

    ngOnInit(): void {

    }

    sendEmail() {
        this.submitLoading = true;

        this.emails.forEach((email, index) => {
            if (email === '') {
                this.emails.splice(index, 1)
            }
        })

        this.clientNotificationService.sendEmail(this.clientNf.id, this.emails.join(','), this.textAreaMessage).subscribe(email => {
            this.openSnackBar('Success!', 'Success!')
            this.submitLoading = false;
            this.dialogRef.close('Success!');
        }, error => {
            this.openSnackBar(error.message, 'Error!');
            this.submitLoading = false;
        })
    }

    addEmail() {
        this.emails.push('')
    }

    deleteEmail(index: number) {
        if (!this.submitLoading) {
            this.emails.splice(index, 1)
        }
    }

    openSnackBar(message: string, type: string) {
        let panelClass = 'client-snackbar';

        if (type === 'Error!') {
            panelClass = 'error-snackbar'
        }

        this.snackBar.open(message, '', {
            duration: 5000,
            panelClass,
            verticalPosition: 'top',
        });
    }

    closeDialog() {
        this.dialogRef.close('close-button');
    }

}
